export default {
  type: 'Tipo',
  relevanceNo: "Numero d'ordine associato",
  consultContent: 'Contenuto della consultazione',
  submitTime: 'Ora di invio',
  consultTypeEnum: {
    0: 'Richiesta ordine',
    1: 'Consultazione pacco',
  },
  consultStatusEnum: {
    0: 'non trattato',
    1: 'in corso di elaborazione',
    2: 'completato',
  },
}
